const formatPeriodicityCheckout = periodicity => {
  if (periodicity === 1) {
    return 'por mês'
  }

  if (periodicity === 12) {
    return 'por ano'
  }

  return `a cada ${periodicity} meses`
}

export default formatPeriodicityCheckout
